<template>
    <div style='background-color:#f2f2f2'>
        <transition name="fade">
            <div v-if="dataLoadingInStoreStatus" class="loading">
                <p>Loading..</p>
            </div>
        </transition>

        <b-container>
            <b-row>
                <b-col style='margin-top:10px'>
                    <h4>Home</h4>
                </b-col>
            </b-row>
            <b-row  v-if = 'lengthOfNews'  style='background-color:white; border-radius: 15px;'>
                <b-col>
                    <div class="input-group" style='margin-top:10px; margin-bottom:10px'>
                            <b-button squared v-b-toggle.collapse-news class="btn btn-secondary" type="button">Activity</b-button>
                            <div class="input-group-append">
                            <b-button v-b-toggle.collapse-news class="btn btn-secondary" type="button"> 
                                <font-awesome-icon icon="caret-down" />
                            </b-button>
                            </div>
                    </div>
                    <b-collapse visible id="collapse-news">

                    <table class='table  table-responsive'>
                        <tbody >
                            <div>
                                <tr v-for="(item, index) in newsFeed" :key="index">
                                    <footer class="blockquote-footer" style='margin-left:5px' >{{item.date}}</footer>
                                    <div style='margin-left:5px' > 
                                        {{item.feedString}}
                                    </div>
                                </tr>
                            </div>
                        </tbody>
                    </table>
                    </b-collapse>
                </b-col>
            </b-row>
            <br>


            <b-row  v-if = 'lengthOfEvents'  style='background-color:white; border-radius: 15px;'>
                <b-col>
                    <div class="input-group" style='margin-top:10px'>
                        <b-button squared v-b-toggle.collapse-events class="btn btn-secondary" type="button">Events</b-button>
                        <div class="input-group-append">

                            <b-button v-b-toggle.collapse-events class="btn btn-secondary" type="button"> 
                                <font-awesome-icon icon="caret-down" />
                            </b-button>
                        </div>
                    </div>
                        <b-collapse visible id="collapse-events">
                             <events/>
                        </b-collapse>
                </b-col>
            </b-row>

            <b-row><br></b-row>
        

            <b-row>
                <b-col>
                    <br>
                </b-col>
            </b-row>


            <b-row style='background-color:white; border-radius: 15px'>
                <b-col style='margin-top:10px'>
                    <h4>New Beers From Your Favorite Breweries</h4>
                    <beertable  v-if = 'lengthOfFavBeers' :everyAvailableBeer="favoriteBeersList" :shouldShowSearch = 0 :shouldAllowShopping=1 />
                    <div v-else><i>Nothing in your favorite brewers. Go to <router-link to="allbeers" >FIND BEERS</router-link> and add some breweries to your favorites list</i></div>
                </b-col>
            </b-row>
        </b-container>
        <footer><pagefooter/></footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Sendmessage from './Sendmessage'
    import Beertable from './Beertable'
    import Events from './Events'
    import Pagefooter from './Pagefooter'

    export default {
        components: {
            Sendmessage,
            Beertable,
            Events,
            Pagefooter
        },
        watch: {
            dataLoadingInStoreStatus(newValue, oldValue) {
            },
        },


        data() {
            return {
                loading:false,
            }
        },
        computed: {
            ...mapState(['favoriteBeersList', 'newsFeed', 'pubEvents', 'dataLoadingInStoreStatus']),
            lengthOfEvents(){
                return this.pubEvents.length
            },
            lengthOfNews(){
                return this.newsFeed.length
            },

            lengthOfFavBeers(){
                return this.favoriteBeersList.length
            },
        },
        methods: {


        },
    }
</script>
